import React from 'react'
import { Item } from 'lib/ui'

const ForwardedHeader = React.forwardRef(function ForwardedHeader(props, ref) {
  return <Item.Header ref={ref} {...props} />
})

export default ForwardedHeader
